import React, { useState } from "react";
import {
  SubscriptionContainer,
  SubscriptionHead,
  SubscriptionHeading,
  SubscriptionDescription,
  SubscriptionPills,
  SubscriptionBottom,
  SubscriptionCards,
  SubscriptionCard,
  SubscriptionTag,
  SubscriptionCardDescription,
  SubscriptionPriceTag,
  TagSpan,
  SubscriptionDetails,
  SubscriptionDetail,
  SubscriptionButton,
  SubscriptionButtonContainer,
  ContactUsTag,
} from "./styles";
import Icon from "../../../../../common/Icon";
import callAPI from "../../../../../api/apiCaller";
import { Context } from "../../../../../Store";
import { getUserInfo } from "../../../../../Store/User/accessors";
import { checkIfTokenValid } from "../../../../../common/utils";
import { loginUser } from "../../../../../Store/User/actions";

const Subscription = ({
  setIsPaymentOpen,
  setIsPremiumOpen,
  setPlan,
  setShowAddProgram,
  getPrograms,
  program,
}) => {
  const { state, dispatch } = React.useContext(Context);

  const [loader, setLoader] = useState(false);

  const userData = getUserInfo(state);

  const createSubscriptionHandler = () => {
    setLoader(true);
    callAPI(dispatch, "createBasicSubscription", {
      userId: userData?.id,
      userEmail: userData?.email,
      plan: "Basic",
      programId: program?.id ? program?.id : "",
    })
      .then((res) => {
        /**  Call Get User API **/
        checkIfTokenValid(dispatch)
          .then((res) => {
            dispatch(loginUser(res));
          })
          .catch((err) => {});
        /**  Call Get User API **/

        /**  Call Get Programs API **/
        if (getPrograms) {
          getPrograms();
        }
        /**  Call Get Programs API **/

        if (setShowAddProgram) {
          setShowAddProgram(true);
        }
      })
      .catch((error) => {
        if (setShowAddProgram) {
          setShowAddProgram(false);
        }
      })
      .finally(() => {
        setIsPaymentOpen(false);
        setIsPremiumOpen(false);
        setLoader(false);
      });
  };

  const navigationHandler = () => {
    window.open("info@onemauve.com");
  };
  return (
    <>
      <SubscriptionContainer>
        <SubscriptionHead>
          <SubscriptionHeading>
            Choosing a best-fit plan for you!
          </SubscriptionHeading>
          <SubscriptionDescription>
            Select the plan that best fits your programs needs
          </SubscriptionDescription>
          <SubscriptionPills></SubscriptionPills>
        </SubscriptionHead>
        <SubscriptionBottom>
          <SubscriptionCards>
            <SubscriptionCard>
              <SubscriptionTag>Basic</SubscriptionTag>
              <SubscriptionCardDescription>
                Perfect for small teams or pilot launches. Supports up to 100
                users with core features to get started.
              </SubscriptionCardDescription>
              <SubscriptionPriceTag>Free</SubscriptionPriceTag>
              <SubscriptionDetails>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Up to 100 participants
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />1 program
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Access to core platform features.
                </SubscriptionDetail>
              </SubscriptionDetails>
              <SubscriptionButtonContainer>
                <SubscriptionButton
                  // disabled={
                  //   userData?.subscription?.plan === "Basic" &&
                  //   userData?.subscription?.status === "active"
                  // }
                  onClick={createSubscriptionHandler}
                >
                  {loader ? <Icon type={"loading"} /> : "Get Started"}
                </SubscriptionButton>
              </SubscriptionButtonContainer>
            </SubscriptionCard>

            <SubscriptionCard>
              <SubscriptionTag>Pro</SubscriptionTag>
              <SubscriptionCardDescription>
                Ideal for growing programs with up to 250 users. Includes
                priority support.
              </SubscriptionCardDescription>
              <SubscriptionPriceTag>$2/user/mo</SubscriptionPriceTag>
              <SubscriptionDetails>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  250 seats
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />1 program
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Access to core platform features.
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Dedicated account manager
                </SubscriptionDetail>
              </SubscriptionDetails>
              <SubscriptionButtonContainer>
                <SubscriptionButton
                  // disabled={
                  //   userData?.subscription?.plan === "Pro" &&
                  //   userData?.subscription?.status === "active"
                  // }
                  onClick={() => {
                    setIsPaymentOpen(true);
                    setIsPremiumOpen(false);
                    setPlan("Pro");
                  }}
                >
                  Get Started
                </SubscriptionButton>
              </SubscriptionButtonContainer>
            </SubscriptionCard>

            <SubscriptionCard>
              <SubscriptionTag>Pro Plus</SubscriptionTag>
              <SubscriptionCardDescription>
                Built for organizations running large mentorship initiatives.
              </SubscriptionCardDescription>
              <SubscriptionPriceTag>Contact us</SubscriptionPriceTag>
              <SubscriptionDetails>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  1000 seats
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />1 program
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Access to core platform features
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Dedicated account manager
                </SubscriptionDetail>
                <SubscriptionDetail>
                  <Icon type={"tick"} size={"20"} />
                  Custom branding
                </SubscriptionDetail>
              </SubscriptionDetails>
              <SubscriptionButtonContainer>
                <ContactUsTag
                  href="mailto:info@onemauve.com"
                  // onClick={navigationHandler}
                  isCustom={true}
                >
                  Contact Us
                </ContactUsTag>
              </SubscriptionButtonContainer>
            </SubscriptionCard>
          </SubscriptionCards>
        </SubscriptionBottom>
      </SubscriptionContainer>
    </>
  );
};

export default Subscription;
